import React from "react";
import AmbientSky from "../components/experience/AmbientSky";
import DayIndicator from "../components/experience/DayIndicator";
import HeroDawn from "../components/experience/HeroDawn";
import PoolMidday from "../components/experience/PoolMidday";
import PlayAfternoon from "../components/experience/PlayAfternoon";
import RoomsGoldenHour from "../components/experience/RoomsGoldenHour";
import NightSpa from "../components/experience/NightSpa";
import ReserveNight from "../components/experience/ReserveNight";

export default function Home() {
  return (
    <div className="relative">
      <AmbientSky />
      <DayIndicator />
      <div className="relative z-10">
        <HeroDawn />
        <PoolMidday />
        <PlayAfternoon />
        <RoomsGoldenHour />
        <NightSpa />
        <ReserveNight />
      </div>
    </div>
  );
}
